import generateJavaRequest from './services/jrequest';

const jrequest = generateJavaRequest('');

// 发票抬头列表
export function titleList() {
  return jrequest('user/invoice/template/list');
}

// 发票抬头信息
export function titleInfo(id) {
  return jrequest('user/invoice/template/info', { id });
}

// 保存发票抬头信息
export function saveTitleInfo(conditions) {
  return jrequest('user/invoice/template/save', conditions, { method: 'post' });
}

// 用户默认抬头
export function userDefaultTitle() {
  return jrequest('user/invoice/template/default');
}

// 查询用户可以开具发票的商品订单集合
export function orderListForInvoice(p) {
  return jrequest('order/list/invoice', { p });
}

// 提交开票请求 待运营审核
export function applyInvoiceIssue(conditions) {
  return jrequest('invoice/apply', conditions, { method: 'post' });
}

// 开票历史
export function invoiceHistoryList(p) {
  return jrequest('invoice/history', { p });
}

// 查询某个开票记录信息
export function getInvoiceInfo(id) {
  return jrequest('invoice/get', { id });
}

// 查询某个开票记录订单信息
export function getInvoiceOrderList(invoiceApplySn) {
  return jrequest('order/info', { invoiceApplySn });
}

// 发票重新发放
export function invoiceResetSend(conditions) {
  return jrequest('invoice/resend', conditions, { method: 'post' });
}

